import React, { Component } from 'react';
import { Link } from "react-router-dom";

import logo from '../img/newbinder-logo.svg';


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: 'en',
      translations: {
      }
    }
  }

  componentDidMount() {
    const location = window.location.pathname;
    console.log(location);
    if(location === "/en/") {
      this.setState({
        lang: 'en',
        translations: {
          title: 'NewBinder App',
          contact: 'Contact',
          contactUrl: 'http://newbinder.pl/en/#kontakt'
        }
      });
    } else if (location === "/de/") {
      this.setState({
        lang: 'de',
        translations: {
          title: 'NewBinder App',
          contact: 'Kontakt',
          contactUrl: 'http://newbinder.pl/de/#kontakt'
        }
      });
    } else {
      this.setState({
        lang: 'pl',
        translations: {
          title: 'NewBinder App',
          contact: 'Kontakt',
          contactUrl: 'http://newbinder.pl/#kontakt'
        }
      });
    }
  }

  handleLanguage = ({target: {name}}) => {
    if(name === 'pl') {
      window.location = '/';
    } else if (name === 'de') {
      window.location = '/de/';
    } else {
      window.location = '/en/';
    }
  }

  render() {
    return (
      <header className="d--flexBetween">
          <div className="d--flex">
            <Link to="/">
              <img src={logo} alt="NEWBINDER"/>
            </Link>
            <p className="p--xl color--black">{this.state.translations.title}</p>
          </div>
          <div className="d--flex">
            <a href={this.state.translations.contactUrl} rel="noopener noreferrer">
              <p className="color--blackSecond"><strong>{this.state.translations.contact}</strong></p>
            </a>
            <button name="pl" className={this.state.lang === "pl" ? "langage--button langauge--selected" : "langage--button"} onClick={this.handleLanguage}>PL</button>
            <button name="en" className={this.state.lang === "en" ? "langage--button langauge--selected" : "langage--button"} onClick={this.handleLanguage}>EN</button>
            <button name="de" className={this.state.lang === "de" ? "langage--button langauge--selected" : "langage--button"} onClick={this.handleLanguage}>DE</button>
          </div>
      </header>
    )
  }
}

export default Header;
